import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

export interface MenuInfo<T> {
  key: T; // enum
  value: string;
  order: number;
  icon: string;
  size: number; // px
  isSvg: boolean;
  classIcon: string;
  classText: string;
  loading?: boolean; // call API
  metadata?: any; // inject data baseon key
}

@Component({
  selector: 'shc-menu-generate',
  templateUrl: './menu-generate.component.html',
  styleUrls: ['./menu-generate.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatMenuModule]
})
export class MenuGenerateComponent {
  @Input() menus: MenuInfo<any>[];

  @Output() clickAction = new EventEmitter<MenuInfo<any>>();

  trackByMenu = (_, menu: MenuInfo<any>) => menu.key;
}
